
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { useState } from 'react';
import { SortableGrid, SortableItem, Size, SortableList, Checkbox, Flex, FlexItem, FlexAlign, FlexJustify, FlexSpacer, Align } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';
export const ControlledField = ({
  defaultValue,
  render
}) => {
  const [items, setItems] = useState(defaultValue);
  return render({
    items,
    onSortEnd: setItems
  });
};
export const Content = () => {
  return <div style={{
    width: '100%',
    height: '100px',
    background: 'red'
  }} />;
};
export const Content2 = () => {
  return <div style={{
    width: '100%',
    height: '50px',
    background: 'blue'
  }} />;
};

const layoutProps = {
  ControlledField,
Content,
Content2
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Sortable`}</h1>
<h2>{`Sortable Grid`}</h2>
<p>{`Usage`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { SortableGrid, SortableItem, SortableList } from '@drawbotics/react-drylus';
`}</code></pre>



<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<ControlledField
  defaultValue={[
    {id: 1, label: 'First' },
    { id: 2, label: 'Second' },
    { id: 3, label: 'Third' },
    { id: 4, label: 'Fourth' },
    { id: 5, label: 'Fifth' },
    { id: 6, label: 'Sixth' },
  ]}
  render={({ items, onSortEnd }) => (
    <SortableGrid items={items} onSortEnd={onSortEnd} hGutters={Size.DEFAULT} vGutters={Size.DEFAULT} columns={3}>
      {items.map((item) => (
        <SortableItem onClickClose={() => {}} key={item.id} label={item.label}>
          <Content />
        </SortableItem>
      ))}
  </SortableGrid>
  )} />`} mode="jsx" component={SortableGrid} mdxType="Playground">
  <ControlledField defaultValue={[{
        id: 1,
        label: 'First'
      }, {
        id: 2,
        label: 'Second'
      }, {
        id: 3,
        label: 'Third'
      }, {
        id: 4,
        label: 'Fourth'
      }, {
        id: 5,
        label: 'Fifth'
      }, {
        id: 6,
        label: 'Sixth'
      }]} render={({
        items,
        onSortEnd
      }) => <SortableGrid items={items} onSortEnd={onSortEnd} hGutters={Size.DEFAULT} vGutters={Size.DEFAULT} columns={3} mdxType="SortableGrid">
        {items.map(item => <SortableItem onClickClose={() => {}} key={item.id} label={item.label} mdxType="SortableItem">
            <Content mdxType="Content" />
          </SortableItem>)}
    </SortableGrid>} mdxType="ControlledField" />
</Playground>
<h3>{`Minimal look (for galleries)`}</h3>
<Playground __position={1} __code={`<ControlledField
  defaultValue={[
    {id: 1 },
    { id: 2 },
    { id: 3 },
    { id: 4 },
    { id: 5 },
    { id: 6 },
    { id: 7 },
    { id: 8 },
    { id: 9 },
    { id: 10 },
  ]}
  render={({ items, onSortEnd }) => (
    <SortableGrid minimal items={items} onSortEnd={onSortEnd} hGutters={Size.DEFAULT} vGutters={Size.DEFAULT} columns={5}>
      {items.map((item) => (
        <SortableItem label={'Image ' + item.id} key={item.id}>
          <img style={{ objectFit: 'cover' }} src="https://www.thespruceeats.com/thmb/iloyF0wMep_WzaEY582p4r_9Ziw=/735x0/how-to-make-your-own-bacon-4146515-17-5b4643f1c9e77c0037514094.jpg" width="100%" height={150} />
        </SortableItem>
      ))}
  </SortableGrid>
  )} />`} mode="jsx" mdxType="Playground">
  <ControlledField defaultValue={[{
        id: 1
      }, {
        id: 2
      }, {
        id: 3
      }, {
        id: 4
      }, {
        id: 5
      }, {
        id: 6
      }, {
        id: 7
      }, {
        id: 8
      }, {
        id: 9
      }, {
        id: 10
      }]} render={({
        items,
        onSortEnd
      }) => <SortableGrid minimal items={items} onSortEnd={onSortEnd} hGutters={Size.DEFAULT} vGutters={Size.DEFAULT} columns={5} mdxType="SortableGrid">
        {items.map(item => <SortableItem label={'Image ' + item.id} key={item.id} mdxType="SortableItem">
            <img style={{
            objectFit: 'cover'
          }} src="https://www.thespruceeats.com/thmb/iloyF0wMep_WzaEY582p4r_9Ziw=/735x0/how-to-make-your-own-bacon-4146515-17-5b4643f1c9e77c0037514094.jpg" width="100%" height={150} />
          </SortableItem>)}
    </SortableGrid>} mdxType="ControlledField" />
</Playground>
<h2>{`Sortable List`}</h2>
<Playground __position={2} __code={`<div style={{ width: 300 }}>
  <ControlledField
    defaultValue={[
      {id: 1, label: 'First' },
      { id: 2, label: 'Second' },
      { id: 3, label: 'Third' },
      { id: 4, label: 'Fourth' },
      { id: 5, label: 'Fifth' },
      { id: 6, label: 'Sixth' },
    ]}
    render={({ items, onSortEnd }) => (
      <SortableList items={items} onSortEnd={onSortEnd}>
        {items.map((item) => (
          <SortableItem onClickClose={() => {}} key={item.id} label={item.label}>
            <Flex style={{ width: '100%' }} align={FlexAlign.CENTER} justify={FlexJustify.END}>
              <FlexItem>
                <Checkbox value={true} onChange={() => {}} />
              </FlexItem>
            </Flex>
          </SortableItem>
        ))}
    </SortableList>
    )} />
</div>`} mode="jsx" component={SortableList} mdxType="Playground">
  <div style={{
        width: 300
      }}>
    <ControlledField defaultValue={[{
          id: 1,
          label: 'First'
        }, {
          id: 2,
          label: 'Second'
        }, {
          id: 3,
          label: 'Third'
        }, {
          id: 4,
          label: 'Fourth'
        }, {
          id: 5,
          label: 'Fifth'
        }, {
          id: 6,
          label: 'Sixth'
        }]} render={({
          items,
          onSortEnd
        }) => <SortableList items={items} onSortEnd={onSortEnd} mdxType="SortableList">
          {items.map(item => <SortableItem onClickClose={() => {}} key={item.id} label={item.label} mdxType="SortableItem">
              <Flex style={{
              width: '100%'
            }} align={FlexAlign.CENTER} justify={FlexJustify.END} mdxType="Flex">
                <FlexItem mdxType="FlexItem">
                  <Checkbox value={true} onChange={() => {}} mdxType="Checkbox" />
                </FlexItem>
              </Flex>
            </SortableItem>)}
      </SortableList>} mdxType="ControlledField" />
  </div>
</Playground>
<h3>{`Align content center or top`}</h3>
<Playground __position={3} __code={`<Flex>
  <FlexItem>
    <div style={{ width: 300 }}>
      <ControlledField
        defaultValue={[
          {id: 1, label: 'First' },
          { id: 2, label: 'Second' },
          { id: 3, label: 'Third' },
          { id: 4, label: 'Fourth' },
          { id: 5, label: 'Fifth' },
          { id: 6, label: 'Sixth' },
        ]}
        render={({ items, onSortEnd }) => (
          <SortableList align={Align.TOP} items={items} onSortEnd={onSortEnd}>
            {items.map((item) => (
              <SortableItem onClickClose={() => {}} key={item.id} label={item.label}>
                 <Content2 />
              </SortableItem>
            ))}
        </SortableList>
        )} />
    </div>
  </FlexItem>
  <FlexSpacer />
  <FlexItem>
    <div style={{ width: 300 }}>
      <ControlledField
        defaultValue={[
          {id: 1, label: 'First' },
          { id: 2, label: 'Second' },
          { id: 3, label: 'Third' },
          { id: 4, label: 'Fourth' },
          { id: 5, label: 'Fifth' },
          { id: 6, label: 'Sixth' },
        ]}
        render={({ items, onSortEnd }) => (
          <SortableList items={items} onSortEnd={onSortEnd}>
            {items.map((item) => (
              <SortableItem onClickClose={() => {}} key={item.id} label={item.label}>
                <Content2 />
              </SortableItem>
            ))}
        </SortableList>
        )} />
    </div>
  </FlexItem>
</Flex>`} mode="jsx" mdxType="Playground">
  <Flex mdxType="Flex">
    <FlexItem mdxType="FlexItem">
      <div style={{
            width: 300
          }}>
        <ControlledField defaultValue={[{
              id: 1,
              label: 'First'
            }, {
              id: 2,
              label: 'Second'
            }, {
              id: 3,
              label: 'Third'
            }, {
              id: 4,
              label: 'Fourth'
            }, {
              id: 5,
              label: 'Fifth'
            }, {
              id: 6,
              label: 'Sixth'
            }]} render={({
              items,
              onSortEnd
            }) => <SortableList align={Align.TOP} items={items} onSortEnd={onSortEnd} mdxType="SortableList">
              {items.map(item => <SortableItem onClickClose={() => {}} key={item.id} label={item.label} mdxType="SortableItem">
                   <Content2 mdxType="Content2" />
                </SortableItem>)}
          </SortableList>} mdxType="ControlledField" />
      </div>
    </FlexItem>
    <FlexSpacer mdxType="FlexSpacer" />
    <FlexItem mdxType="FlexItem">
      <div style={{
            width: 300
          }}>
        <ControlledField defaultValue={[{
              id: 1,
              label: 'First'
            }, {
              id: 2,
              label: 'Second'
            }, {
              id: 3,
              label: 'Third'
            }, {
              id: 4,
              label: 'Fourth'
            }, {
              id: 5,
              label: 'Fifth'
            }, {
              id: 6,
              label: 'Sixth'
            }]} render={({
              items,
              onSortEnd
            }) => <SortableList items={items} onSortEnd={onSortEnd} mdxType="SortableList">
              {items.map(item => <SortableItem onClickClose={() => {}} key={item.id} label={item.label} mdxType="SortableItem">
                  <Content2 mdxType="Content2" />
                </SortableItem>)}
          </SortableList>} mdxType="ControlledField" />
      </div>
    </FlexItem>
  </Flex>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;